import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CustomLoadingPanelComponent } from 'lib-base';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-public-layout',
  standalone: true,
  imports: [RouterOutlet, ToastModule, CustomLoadingPanelComponent],
  template: `
    <p-toast></p-toast>
    <router-outlet></router-outlet>
    <custom-loading-panel></custom-loading-panel>
  `,
  styleUrl: './public-layout.component.scss'
})
export class PublicLayoutComponent {

}
